import React, { Component } from "react";
import { connect } from "react-redux";
import { StyledTable, TwoLineTableRow } from "../../lib/tables/styled-table";
import moment from "moment";
import { withRouter } from "react-router";
import { showModal } from "../../../actions/modal";
import { CONFIRMATION_MODAL } from "../../modals/modal_root";
import { deleteAudioBlock } from "../../../action_managers/audio_management";
import Spinner from "../../lib/spinner";
import { isDefaultAudioBlock } from "../../modals/audio_block_modal_parts/audio_block_modal_helpers";
class AudioBlocksTable extends Component {
  columnInfo = props => [
    {
      accessor: "name",
      Cell: data => {
        const audioBlock = data.original;
        const canEdit = !isDefaultAudioBlock(audioBlock);
        const menuItems = {
          "Assign To Insertion Points": () => {
            props.history.push(`/audio-blocks/${audioBlock.uuid}/assign`);
          },
          ...(!canEdit && {
            View: () => {
              props.history.push(`/audio-blocks/${audioBlock.uuid}`);
            },
          }),
          ...(canEdit && {
            Edit: () => {
              props.history.push(`/audio-blocks/${audioBlock.uuid}/edit`);
            },
            Delete: () => {
              props.confirmModal(() => {
                props.deleteAudioBlock(audioBlock.uuid);
              });
            },
          }),
        };

        return (
          <TwoLineTableRow
            onClick={() =>
              canEdit
                ? props.history.push(`/audio-blocks/${audioBlock.uuid}/edit`)
                : props.history.push(`/audio-blocks/${audioBlock.uuid}`)
            }
            title={data.value}
            subtitle={`Created ${moment.unix(audioBlock.createdAt).format("LL")}`}
            menuItems={menuItems}
          />
        );
      },
    },
  ];

  render() {
    const { audioBlocks = [], isLoading = true } = this.props;
    if (isLoading) {
      return (
        <div className="audio-management-table__loader">
          <Spinner isLoading={isLoading} />
        </div>
      );
    }

    if (!audioBlocks.length) {
      return (
        <div className="audio-management-table__empty-text">
          <p>There are no existing Audio Blocks.</p>
        </div>
      );
    }

    return <StyledTable data={audioBlocks} columns={this.columnInfo(this.props)} noBottomLine />;
  }
}

export default connect(
  state => {
    return {
      isLoading: state.audioBlocks.isLoading,
    };
  },
  {
    confirmModal: callback =>
      showModal(CONFIRMATION_MODAL, {
        callback,
        modalTitle: "Delete audio block",
        confirmationMessage: "Are you sure you want to delete this audio block?",
      }),
    deleteAudioBlock,
  }
)(withRouter(AudioBlocksTable));
